import type { ReactElement } from 'react';
import type { CustomIconProps } from '../types';

export const NavigationSlideArrowLeftIcon = ({ width, height }: CustomIconProps): ReactElement => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || '32'}
        height={height || '32'}
        viewBox="0 0 32 32"
        fill="none"
    >
        <path
            d="M16.0026 30.6666C24.1028 30.6666 30.6693 24.1001 30.6693 15.9999C30.6693 7.89974 24.1028 1.33325 16.0026 1.33325C7.90243 1.33325 1.33594 7.89974 1.33594 15.9999C1.33594 24.1001 7.90243 30.6666 16.0026 30.6666Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 30.6667C24.1002 30.6667 30.6667 24.1002 30.6667 16C30.6667 7.89982 24.1002 1.33333 16 1.33333C7.89982 1.33333 1.33333 7.89982 1.33333 16C1.33333 24.1002 7.89982 30.6667 16 30.6667ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
            fill="#C6C6C6"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.8221 8.18024C19.0593 8.42056 19.0593 8.8102 18.8221 9.05053L12.3926 15.5649C12.1554 15.8052 12.1554 16.1948 12.3926 16.4351L18.8221 22.9495C19.0593 23.1898 19.0593 23.5794 18.8221 23.8198C18.5849 24.0601 18.2003 24.0601 17.9632 23.8198L11.5337 17.3054C10.8221 16.5845 10.8221 15.4155 11.5337 14.6946L17.9632 8.18024C18.2003 7.93992 18.5849 7.93992 18.8221 8.18024Z"
            fill="#414042"
        />
    </svg>
);
